import * as React from 'react';
import { resolve } from 'inversify-react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { parse } from "querystring";

import { ConfirmationQuoteView } from 'src/app/bookings/confirmation-quotes/confirmation-quote.view';
import { ContextService } from 'src/core/services/context.service';
import { ToastNotifications } from 'src/core/ui/toast';
import { ConfirmationQuoteService } from 'src/app/bookings/shared/confirmation-quote.service';
import { DataLocalService } from 'src/core/services/data-local.service';
import { ControllerProps } from 'src/router';

interface ConfirmationQuotesControllerProps extends ControllerProps<{ id: string; }> {
	setBusy(isBusy: boolean);
}

@observer
export class ConfirmationQuoteController extends React.Component<ConfirmationQuotesControllerProps, {}> {

	@resolve
	private toast: ToastNotifications;

	@resolve
	private contextService: ContextService;

	@resolve
	private confirmationQuoteService: ConfirmationQuoteService;

	@observable
	private entryDataService: DataLocalService<ConfirmationQuoteItem>;

	@observable
	private historyDataService: DataLocalService<QuoteEntryStateHistory>;

	private filter: ConfirmationQuoteFilter;

	public componentDidMount() {
		if (this.props.location.search) {
			const query = parse(this.props.location.search.substr(1));
			this.filterQuoteEntry(query).then(() => {
				if (this.filter.id && this.entryDataService.count === 0) {
					this.toast.showToast("Reservation product not found", "It is possible that the item your looking for is deleted, does not require confirmation or have Draft status", "warning")
				}
			});
		}
	}

	public render() {
		return (
			<ConfirmationQuoteView
				filterQuoteEntry={this.filterQuoteEntry}
				model={this.entryDataService}
				setBusy={this.props.setBusy}
				historyDataService={this.historyDataService}
				loadStateHistory={this.loadStateHistory}
				changeStatus={this.changeStatus}
			/>
		);
	}

	private changeStatus = async (
		entry: QuoteEntryItem,
		observations: string,
		confirmationNumber: string,
		rejectedAs?: number
	) => {
		const ctx = await this.contextService.current();
		const result = await ctx.QuoteEntryChangeStatus(entry.id, observations, confirmationNumber, rejectedAs);
		this.toast.showToast('Request succeed!', `Product status changed to ${entry.statusText}`, 'success');
		this.filterQuoteEntry(this.filter);
	}

	private loadStateHistory = (entry: QuoteEntryItem) => {
		const history: QuoteEntryStateHistory[] = entry.dynamicProperties['history'] || [];
		this.historyDataService = new DataLocalService(history);
	}

	private filterQuoteEntry = async (filter: ConfirmationQuoteFilter) => {
		try {
			this.props.setBusy(true);
			this.filter = filter;
			let result = await this.confirmationQuoteService.getConfirmationQuotes(filter);
			if (result) {
				this.entryDataService = new DataLocalService(result);
			}
			this.props.setBusy(false);
		} catch (error) {
			this.props.setBusy(false);
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/confirmation-quotes/confirmation-quote.controller.tsx